$(function() {
	if (!Cookies.get('nbr')) {
		Cookies.set('nbr', 1);
	}
	if (!parseInt(Cookies.get('nbr'))) {
		$('.js-navbar-collapsed').addClass('collapsed');
		$('.js-navbar-visibility')
			.delay(300)
			.queue(function (next) {
    		$(this).css('visibility', '');
    		next();
  		});
	} else {
		$('.js-navbar-active').addClass('active');
		$('.js-navbar-visibility').css('visibility', '');
	}
	if ($(window).width()<768){
		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var navbarHeight = $('.nav-global').outerHeight();

		$(window).scroll(function(event){
	    	didScroll = true;
		});

		setInterval(function() {
		    if (didScroll) {
		        hasScrolled();
		        didScroll = false;
		    }
		}, 250);

		function hasScrolled() {
		    var st = $(this).scrollTop();

		    // Make sure they scroll more than delta
		    if(Math.abs(lastScrollTop - st) <= delta)
		        return;

		    // If they scrolled down and are past the navbar, add class .nav-up.
		    // This is necessary so you never see what is "behind" the navbar.
		    if (st > lastScrollTop && st > navbarHeight){
		        // Scroll Down
		        $('.nav-global').addClass('nav-up');
		    } else {
		        // Scroll Up
		        if(st + $(window).height() < $(document).height()) {
		            $('.nav-global').removeClass('nav-up');
		        }
		    }

		    lastScrollTop = st;
		}
	};

	$('#menu-toggle').on('click',function(e){
		if ($(window).width() > 768) {
		    var $this = $(this);
		    var status = $this.hasClass('collapsed') ? 1 : 0;
				Cookies.set('nbr', status); // Charles
			// $.ajax({
	    //         type: "POST",
	    //         url: '/api/v1/toggle-navbar',
	    //         headers: {
	    //             'X-CSRFToken': csrftoken
	    //         },
	    //         data: {status: status},
	    //         success: function(){
	    //             // $('.js-cookie-banner').fadeOut()
	    //             // toastr.success('Modification saved');
	    //         },
	    //         error: function(xhr) {
	    //             console.log(xhr.responseJSON)
	    //             // N)
	    //             // toastr.warning(xhr.responseJSON);
	    //         }
	    //     });
		};
	});

	$(window).resize(function(){
		if ($(window).width() < 769) {
			Cookies.set('nbr', 0); // Charles
			// $.ajax({
	    //         type: "POST",
	    //         url: '/api/v1/toggle-navbar',
	    //         headers: {
	    //             'X-CSRFToken': csrftoken
	    //         },
	    //         data: {status: false},
	    //         success: function(){
	    //             // $('.js-cookie-banner').fadeOut()
	    //             // toastr.success('Modification saved');
	    //         },
	    //         error: function(xhr) {
	    //             console.log(xhr.responseJSON)
	    //             // N)
	    //             // toastr.warning(xhr.responseJSON);
	    //         }
	    //     });
		};
	});

	// $('#navbarClose').on('click',function(e){
	//     var $this = $(this)
	//     var status = $this.hasClass('collapsed')
    //     $.ajax({
    //         type: "POST",
    //         url: '/api/v1/toggle-navbar',
    //         headers: {
    //             'X-CSRFToken': csrftoken
    //         },
    //         data: {status: status},
    //         success: function(){
    //             // $('.js-cookie-banner').fadeOut()
    //             // toastr.success('Modification saved');
    //         },
    //         error: function(xhr) {
    //             console.log(xhr.responseJSON)
    //             // N)
    //             // toastr.warning(xhr.responseJSON);
    //         }
    //     });
	// });
});
